import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { gradient, greys, time } from "@clockwise/web-commons/src/styles/color.styles";
import {
  legendFocusDot,
  legendBusyDot,
} from "@components/team-health-summary/TeamHealthSummary.styles";

export const container: CSSProperties = {
  position: "relative",
  display: "inline-block",
  height: "100%",
};

const baseCircularProgress: CSSProperties = {
  position: "absolute",
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  transform: `rotate(-90deg)`,
  strokeLinecap: "round",
};

export const focusTime = {
  thickness: 3,
  style: {
    ...baseCircularProgress,
    color: time.focus,
    zIndex: 2,
  } as CSSProperties,
};

export const busyTime = {
  thickness: 3,
  style: {
    ...baseCircularProgress,
    color: time.busy,
    zIndex: 1,
  } as CSSProperties,
};

export const loadingTime = {
  ...focusTime,
  style: {
    ...baseCircularProgress,
    color: greys.cloudyBlue,
  },
};

export const teammate: CSSProperties = {
  flexGrow: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

export const avatarContainer: CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const teammateName: CSSProperties = {
  fontSize: 12,
  marginTop: 4,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  transition: "all .4s",
};

export const addCircleColor = greys.blueGrey;
export const addCircleColorHovered = greys.slate;

export const addContainer: CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
};

export const addCircle: CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "50%",
  borderWidth: 2,
  borderStyle: "solid",
  borderColor: addCircleColor,
  transition: "border-color .4s",
};

//////////////////
// TOOL-TIP
//////////////////
export const toolTipRow: CSSProperties = {
  display: "flex",
  alignItems: "center",
  padding: "2px 0",
};

export const focusDot: CSSProperties = {
  ...legendFocusDot,
};

export const busyDot: CSSProperties = {
  ...legendBusyDot,
  marginLeft: 0,
};

export const toolTipTextOnly: CSSProperties = {
  textAlign: "center",
};

//////////////////
// AVATAR STUFF
//////////////////

export const avatarImg: CSSProperties = {
  overflow: "hidden",
  flexShrink: 0,
  borderRadius: "50%",
};

export const avatarInitials: CSSProperties = {
  ...avatarImg,
  background: gradient,
  color: "white",
  fontWeight: 600,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};
